<template>
  <div
    class="flex items-center bg-gray-800 border-b border-gray-700 min-h-[2.25rem]"
    :class="isActive ? 'border-t-2 border-t-blue-500' : 'border-t-2 border-t-transparent'"
  >
    <!-- File tabs (scrollable) -->
    <div class="flex items-center overflow-x-auto flex-1 min-w-0 scrollbar-none">
      <button
        v-for="file in column?.openFiles"
        :key="file.path"
        :class="[
          'flex items-center gap-1.5 px-3 py-1.5 text-xs whitespace-nowrap border-r border-gray-700 transition-colors shrink-0',
          file.path === column?.activeFile?.path
            ? 'bg-gray-900 text-white'
            : 'text-gray-400 hover:bg-gray-700 hover:text-white',
        ]"
        @click="editorStore.openFile(file.path, props.columnId)"
      >
        <span>{{ fileName(file.path) }}</span>
        <span v-if="file.isDirty" class="text-yellow-400 text-[10px]">●</span>
        <span
          class="ml-0.5 text-gray-500 hover:text-red-400"
          @click.stop="editorStore.closeFile(file.path, props.columnId)"
        >×</span>
      </button>
    </div>

    <!-- Split editor right -->
    <button
      v-if="editorStore.columns.length < 10"
      class="shrink-0 px-2 h-full flex items-center text-gray-500 hover:text-gray-200 hover:bg-gray-700 transition-colors border-l border-gray-700"
      title="Split editor right"
      @click="editorStore.addColumn()"
    >
      <!-- Two-pane icon -->
      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="5.5" height="11" rx="1" stroke="currentColor" stroke-width="1"/>
        <rect x="8" y="0.5" width="5.5" height="11" rx="1" stroke="currentColor" stroke-width="1"/>
      </svg>
    </button>

    <!-- Close this column (only when > 1 column exists) -->
    <button
      v-if="editorStore.columns.length > 1"
      class="shrink-0 px-2 h-full flex items-center text-gray-500 hover:text-red-400 hover:bg-gray-700 transition-colors border-l border-gray-700 text-sm leading-none"
      title="Close column"
      @click="editorStore.removeColumn(props.columnId)"
    >×</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useEditorStore } from '@/stores/editorStore'

const props = defineProps<{ columnId: string }>()

const editorStore = useEditorStore()

const column   = computed(() => editorStore.columns.find(c => c.id === props.columnId))
const isActive = computed(() => editorStore.activeColumnId === props.columnId)

function fileName(path: string): string {
  return path.split('/').pop() ?? path
}
</script>
